import { useSelector } from "react-redux"
import { useParams } from "react-router"

import ScheduleScreenContent from "./ScheduleScreenContent"
import { ScheduleButtons, RightMenu } from "components"

export default function SingleMemberScheduleScreen({ view }) {
  const { memberId } = useParams()
  const member = useSelector((state) => state.members[memberId])
  const isMember = useSelector((state) => state.auth.isMember)
  const allowTaskTransfer = useSelector((state) => state.teamStatus.allowTaskTransfer)
  const authMemberId = useSelector((state) => state.auth.memberId)
  const currentMemberShowOnPlan = useSelector((state) => authMemberId && state.members[authMemberId] ? state.members[authMemberId].showOnPlan : true)
  const rightMenuVisible = useSelector((state) => state.visual.rightMenuVisible)
  const showRightMenu = useSelector((state) => state.teamStatus.showProjects || state.teamStatus.showAnalyses)
  // SPEC-066 (#4180): visible to VIEW_ONLY as well (read-only inside the menus).
  const showSidebars = !isMember || currentMemberShowOnPlan || allowTaskTransfer

  return (
    <div className="ScheduleScreen">
      {showRightMenu && showSidebars && <RightMenu open={rightMenuVisible} />}
      <ScheduleButtons type="single-member" moveRight={rightMenuVisible && showRightMenu && showSidebars} view={view} />
      <ScheduleScreenContent moveRight={rightMenuVisible && showRightMenu && showSidebars} singleMember members={[member]} view={view} />
    </div>
  )
}
